// extracted by mini-css-extract-plugin
module.exports = {"container":"EditVideo_container__3VdXJ","titleRow":"EditVideo_titleRow__WiK6t","arrow":"EditVideo_arrow__3szd4","warning":"EditVideo_warning__2BUfz"};